module.exports = __webpack_public_path__ + "static/media/department.2aaa9c91.svg";